import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
`

export const LogoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: var(--space-600);

  display: block;
`

export const Main = styled.div<{ $maxWidth?: number }>`
  max-width: ${({ $maxWidth = 498 }) => $maxWidth}px;

  text-align: center;
`

export const LoaderContainer = styled.div`
  margin-bottom: var(--space-400);

  display: flex;
  justify-content: center;
`

export const Description = styled.div`
  margin-top: var(--space-400);

  font-size: var(--font-size-400);
  color: var(--text-primary);
`

export const ActionsContainer = styled.div`
  margin-top: var(--space-600);

  display: flex;
  justify-content: center;
`
